export default {};

export const csvAcceptedFormats = [
  '.csv',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/comma-separated-values',
];
